var _path, _ellipse, _ellipse2, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _rect4, _rect5, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCelebration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 213,
    viewBox: "0 0 318 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M57.623 20.5752L45.6164 39.3282C45.6164 39.3282 40.5269 31.7885 35.9065 27.9182C29.4833 22.5376 11.5395 27.1509 11.5395 27.1509L27.2003 2.69044C27.2003 2.69044 32.7469 14.9952 40.0989 18.638C46.2759 21.6987 57.623 20.5752 57.623 20.5752Z",
    fill: "#FFC3E7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.23,
    rx: 7.81191,
    ry: 7.28337,
    transform: "matrix(-0.970065 0.242845 -0.208244 -0.978077 9.09467 118.941)",
    fill: "#A940F7"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.74,
    rx: 7.81192,
    ry: 8.40137,
    transform: "matrix(-0.970065 0.242845 -0.208244 -0.978077 90.439 157.611)",
    fill: "#FDDA60"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93.1806,
    cy: 30.9421,
    r: 3.79096,
    fill: "#FFDB72"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.291,
    cy: 175.219,
    r: 3.79096,
    fill: "#FFDB72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M167.753 26.2295L160.554 22.2522C160.554 22.2522 166.078 17.1859 168.076 13.7968C170.853 9.08522 168.251 0.000108961 168.251 0.000108961L177.64 5.18782L167.753 26.2295Z",
    fill: "#89C5FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M297.39 129.955L290.191 125.977C290.191 125.977 295.714 120.911 297.712 117.522C300.49 112.81 297.887 103.725 297.887 103.725L307.277 108.913L297.39 129.955Z",
    fill: "#89C5FD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M201.113 35.5967L206.833 26.1177C206.833 26.1177 212.786 33.4049 216.923 36.0436C222.673 39.7119 234.483 36.2985 234.483 36.2985L227.022 48.6623L201.113 35.5967Z",
    fill: "#FCD54A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M15.9805 166.978L10.0011 157.66C10.0011 157.66 19.168 155.536 23.3619 152.99C29.1923 149.451 31.3442 137.347 31.3442 137.347L39.1434 149.5L15.9805 166.978Z",
    fill: "#FCD54A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M54.2578 117.756L51.5788 122.447C51.5788 122.447 56.4488 123.468 58.7501 124.723C61.9493 126.468 63.6321 132.516 63.6321 132.516L67.1264 126.397L54.2578 117.756Z",
    fill: "#A0CDF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M284.867 40.0991L279.821 42.0284C279.821 42.0284 282.94 45.9053 283.924 48.3349C285.292 51.7125 282.759 57.4566 282.759 57.4566L289.341 54.9401L284.867 40.0991Z",
    fill: "#A0CDF0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.34,
    x: 124.241,
    y: 19.2139,
    width: 3.50197,
    height: 11.596,
    rx: 1,
    transform: "rotate(47.7394 124.241 19.2139)",
    fill: "#C06DE7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.34,
    x: 302.309,
    y: 55.1487,
    width: 3.50197,
    height: 11.596,
    rx: 1,
    transform: "rotate(47.7394 302.309 55.1487)",
    fill: "#C06DE7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.0391,
    y: 100.724,
    width: 3.50197,
    height: 11.596,
    rx: 1,
    transform: "rotate(128.205 38.0391 100.724)",
    fill: "#FEAC06"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 317.639,
    y: 208.749,
    width: 3.50197,
    height: 11.596,
    rx: 1,
    transform: "rotate(128.205 317.639 208.749)",
    fill: "#FEAC06"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 263.801,
    y: 18.9316,
    width: 3.50198,
    height: 11.596,
    rx: 1,
    transform: "rotate(-147.025 263.801 18.9316)",
    fill: "#FEAC06"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1768 155.898H220.161L213.628 167.871L220.161 179.845H78.1768V155.898Z",
    fill: "#5D33C3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.632 163.193L103.738 165.033C103.154 164.624 102.476 164.383 101.774 164.334C101.023 164.334 100.622 164.69 100.622 165.241C100.622 165.806 101.539 166.21 102.645 166.701C103.726 167.178 104.913 168.135 104.913 169.46C104.913 171.876 103.15 172.722 101.257 172.722C99.9295 172.735 98.6396 172.262 97.6123 171.385L98.7177 169.448C98.7177 169.448 100.011 170.588 101.093 170.588C101.574 170.588 102.492 170.539 102.492 169.595C102.492 168.859 101.457 168.528 100.305 167.926C99.1407 167.326 98.459 166.381 98.459 165.327C98.459 163.438 100.06 162.237 101.622 162.237C102.693 162.244 103.739 162.576 104.632 163.193Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M112.874 169.827L113.815 171.789C113.815 171.789 112.733 172.721 110.628 172.721C107.889 172.721 105.373 170.392 105.373 167.497C105.373 164.591 107.877 162.237 110.628 162.237C112.733 162.237 113.815 163.169 113.815 163.169L112.874 165.131C112.314 164.726 111.65 164.508 110.969 164.505C108.748 164.505 107.771 166.124 107.771 167.473C107.771 168.834 108.747 170.453 110.969 170.453C111.65 170.45 112.314 170.232 112.874 169.827Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M117.108 172.537H114.897V162.42H117.108V166.457H120.235V162.422H122.446V172.54H120.235V168.481H117.108V172.537Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M128.549 162.237C129.2 162.242 129.844 162.381 130.443 162.648C131.042 162.915 131.585 163.303 132.039 163.79C132.493 164.277 132.849 164.854 133.088 165.486C133.326 166.118 133.442 166.794 133.428 167.473C133.428 170.428 131.335 172.721 128.549 172.721C125.68 172.721 123.658 170.428 123.658 167.473C123.647 166.794 123.765 166.119 124.006 165.487C124.246 164.856 124.604 164.28 125.058 163.793C125.513 163.307 126.055 162.919 126.654 162.651C127.253 162.384 127.897 162.244 128.549 162.237V162.237ZM128.549 170.489C130.312 170.489 131.041 168.981 131.041 167.473C131.041 165.964 130.265 164.457 128.549 164.457C126.844 164.457 126.044 165.964 126.044 167.473C126.044 168.981 126.738 170.489 128.549 170.489Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M139.096 162.237C139.748 162.242 140.392 162.381 140.991 162.648C141.59 162.915 142.133 163.303 142.587 163.79C143.041 164.277 143.397 164.854 143.636 165.486C143.874 166.118 143.99 166.794 143.976 167.473C143.976 170.428 141.883 172.721 139.096 172.721C136.228 172.721 134.206 170.428 134.206 167.473C134.195 166.794 134.313 166.119 134.553 165.487C134.794 164.856 135.152 164.28 135.606 163.793C136.061 163.307 136.603 162.919 137.202 162.651C137.801 162.384 138.445 162.244 139.096 162.237V162.237ZM139.096 170.489C140.86 170.489 141.589 168.981 141.589 167.473C141.589 165.964 140.813 164.457 139.096 164.457C137.392 164.457 136.592 165.964 136.592 167.473C136.592 168.981 137.286 170.489 139.096 170.489Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M147.399 170.514H150.738V172.537H145.188V162.42H147.399V170.514Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M157.722 170.514H161.061V172.537H155.512V162.42H157.722V170.514Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M167.94 164.445H164.601V166.454H167.799V168.478H164.601V170.513H167.94V172.536H162.391V162.419H167.94V164.445Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M178.357 172.537H175.983L175.266 170.514H171.575L170.856 172.537H168.481L172.396 162.42H174.442L178.357 172.537ZM173.431 165.548H173.408L172.326 168.491H174.514L173.431 165.548Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M187.741 169.067C187.212 171.629 185.166 172.721 183.261 172.721C180.651 172.721 178.535 170.379 178.535 167.485C178.535 164.579 180.534 162.237 183.261 162.237C184.966 162.237 186.154 162.899 187 163.966L185.554 165.621C185.343 165.219 185.029 164.884 184.648 164.655C184.266 164.426 183.831 164.31 183.391 164.321C182.027 164.321 180.922 165.732 180.922 167.485C180.922 169.202 182.027 170.6 183.391 170.6C184.449 170.6 185.496 169.888 185.496 168.65H183.261V166.872H187.741V169.067Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M196.408 168.943C196.408 171.445 195.091 172.72 192.622 172.72C190.153 172.72 188.836 171.445 188.836 168.943V162.42H191.047V168.269C191.047 169.961 191.541 170.452 192.622 170.452C193.703 170.452 194.197 169.961 194.197 168.269V162.42H196.408V168.943Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M203.486 164.445H200.146V166.454H203.344V168.478H200.146V170.513H203.486V172.536H197.937V162.419H203.486V164.445Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.6898 150.714L74.2099 141.315C73.8884 141.15 73.5334 141.064 73.1732 141.063C72.813 141.062 72.4577 141.147 72.1354 141.31L53.5304 150.709C52.842 151.062 52.3669 151.736 52.2695 152.512C52.2394 152.74 49.6156 175.401 72.0659 187.778C72.411 187.969 72.7985 188.067 73.1916 188.063C73.5847 188.059 73.9703 187.954 74.3119 187.757C95.8837 175.399 94.0457 153.513 93.9576 152.587C93.9196 152.192 93.7834 151.812 93.5617 151.485C93.34 151.157 93.04 150.892 92.6898 150.714V150.714Z",
    fill: "white"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7616 152.077L74.1 143.602C73.8101 143.454 73.4901 143.376 73.1653 143.375C72.8406 143.375 72.5202 143.451 72.2297 143.598L55.4552 152.073C54.8346 152.39 54.4062 152.998 54.3184 153.698C54.2912 153.903 51.9256 174.335 72.167 185.494C72.4781 185.666 72.8275 185.754 73.1819 185.751C73.5363 185.748 73.884 185.652 74.192 185.475C93.6413 174.333 91.9841 154.6 91.9047 153.765C91.8705 153.409 91.7477 153.067 91.5478 152.772C91.3479 152.476 91.0774 152.237 90.7616 152.077V152.077Z",
    fill: "#FFD60D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.2613 145.291L73.259 145.29C73.2287 145.275 73.1952 145.267 73.1612 145.267C73.1272 145.266 73.0936 145.274 73.0632 145.29L73.0616 145.291L56.2939 153.762C56.2201 153.8 56.1772 153.869 56.1688 153.936L56.168 153.943L56.1672 153.949C56.1674 153.947 56.1672 153.949 56.1667 153.953C56.1479 154.13 55.6397 158.91 57.4284 164.944C59.2469 171.078 63.4393 178.53 73.0581 183.832L73.0601 183.833C73.0922 183.851 73.1281 183.86 73.1646 183.86C73.2011 183.86 73.2369 183.85 73.2685 183.832L73.2714 183.83L73.2743 183.828C91.6805 173.284 90.115 154.654 90.0482 153.949C90.0445 153.91 90.0313 153.874 90.0098 153.842C89.9884 153.81 89.9593 153.784 89.9254 153.767L90.7572 152.086L89.9252 153.767L73.2613 145.291ZM91.9047 153.765C91.9841 154.6 93.6413 174.333 74.192 185.475C73.884 185.652 73.5363 185.748 73.1819 185.751C72.8275 185.754 72.4781 185.666 72.167 185.494C51.9256 174.335 54.2912 153.903 54.3184 153.698C54.4062 152.998 54.8346 152.39 55.4552 152.073L72.2297 143.598C72.5202 143.451 72.8406 143.375 73.1653 143.375C73.4901 143.376 73.8101 143.454 74.1 143.602L90.7616 152.077C91.0774 152.237 91.3479 152.476 91.5478 152.772C91.7477 153.067 91.8705 153.409 91.9047 153.765Z",
    fill: "#FEAC06"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4912 159.83V168.107C63.4912 168.376 63.7061 168.594 63.9715 168.594H66.3727V158.856H64.4517C63.9213 158.856 63.4912 159.292 63.4912 159.83ZM74.297 158.369H73.5766V157.152C73.5766 157.017 73.4691 156.909 73.3364 156.909H72.8562C72.7235 156.909 72.6161 157.017 72.6161 157.152V159.1C72.6161 159.234 72.7235 159.343 72.8562 159.343H74.297C74.4296 159.343 74.5371 159.234 74.5371 159.1V158.613C74.5371 158.478 74.4296 158.369 74.297 158.369ZM78.4317 156.423L73.6291 153.177C73.4713 153.07 73.2859 153.013 73.0963 153.013C72.9067 153.013 72.7213 153.07 72.5635 153.177L67.761 156.423C67.6294 156.512 67.5216 156.632 67.447 156.774C67.3723 156.915 67.3333 157.073 67.3333 157.233V168.594H71.1753V164.212C71.1753 163.943 71.3902 163.725 71.6556 163.725H74.5371C74.8024 163.725 75.0173 163.943 75.0173 164.212V168.594H78.8594V157.233C78.8594 156.908 78.6988 156.603 78.4317 156.423ZM73.0963 160.804C71.7702 160.804 70.695 159.714 70.695 158.369C70.695 157.025 71.7702 155.935 73.0963 155.935C74.4224 155.935 75.4976 157.025 75.4976 158.369C75.4976 159.714 74.4224 160.804 73.0963 160.804ZM81.7409 158.856H79.8199V168.594H82.2212C82.4865 168.594 82.7014 168.376 82.7014 168.107V159.83C82.7014 159.292 82.2713 158.856 81.7409 158.856Z",
    fill: "#FE9B06"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.0171 147.053C73.246 147.053 73.4316 147.241 73.4316 147.473L73.4316 150.808C73.4316 151.04 73.246 151.228 73.017 151.228C72.7881 151.228 72.6025 151.04 72.6025 150.808L72.6026 147.473C72.6026 147.241 72.7881 147.053 73.0171 147.053Z",
    fill: "#FEAC06"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.1225 172.752C73.3514 172.752 73.537 172.94 73.537 173.172V180.289C73.537 180.521 73.3514 180.71 73.1225 180.71C72.8936 180.71 72.708 180.521 72.708 180.289V173.172C72.708 172.94 72.8936 172.752 73.1225 172.752Z",
    fill: "#FEAC06"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.749 162.857C84.749 162.625 84.9346 162.437 85.1635 162.437H87.2331C87.462 162.437 87.6476 162.625 87.6476 162.857C87.6476 163.09 87.462 163.278 87.2331 163.278H85.1635C84.9346 163.278 84.749 163.09 84.749 162.857Z",
    fill: "#FEAC06"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4561 163.181C61.4561 162.949 61.2705 162.761 61.0415 162.761H58.972C58.7431 162.761 58.5575 162.949 58.5575 163.181C58.5575 163.413 58.7431 163.601 58.972 163.601H61.0415C61.2705 163.601 61.4561 163.413 61.4561 163.181Z",
    fill: "#FEAC06"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.0859 149.837C79.2923 149.937 79.3793 150.188 79.2803 150.398L78.2258 152.625C78.1267 152.834 77.8791 152.922 77.6727 152.822C77.4664 152.721 77.3794 152.47 77.4784 152.261L78.5329 150.034C78.6319 149.825 78.8795 149.736 79.0859 149.837Z",
    fill: "#FEAC06"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0122 149.851C66.8111 149.962 66.7367 150.217 66.8461 150.421L68.0816 152.725C68.191 152.928 68.4427 153.004 68.6438 152.893C68.8449 152.782 68.9193 152.527 68.8099 152.323L67.5744 150.02C67.465 149.816 67.2133 149.741 67.0122 149.851Z",
    fill: "#FEAC06"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.3947 152.657C84.5598 152.817 84.565 153.083 84.4064 153.251L81.8062 155.994C81.6476 156.162 81.3852 156.167 81.2201 156.006C81.055 155.846 81.0498 155.579 81.2084 155.412L83.8086 152.668C83.9672 152.501 84.2296 152.496 84.3947 152.657Z",
    fill: "#FEAC06"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7955 152.659C61.6317 152.821 61.6285 153.087 61.7884 153.253L64.4031 155.969C64.563 156.135 64.8254 156.138 64.9893 155.976C65.1531 155.814 65.1563 155.548 64.9964 155.382L62.3817 152.666C62.2218 152.5 61.9594 152.497 61.7955 152.659Z",
    fill: "#FEAC06"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.9581 156.067C88.0822 156.262 88.0268 156.522 87.8345 156.648L85.0123 158.494C84.8199 158.619 84.5633 158.563 84.4393 158.368C84.3152 158.173 84.3706 157.913 84.5629 157.787L87.3851 155.942C87.5775 155.816 87.8341 155.872 87.9581 156.067Z",
    fill: "#FEAC06"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2242 156.083C58.1089 156.284 58.1758 156.541 58.3736 156.658L61.2224 158.342C61.4201 158.459 61.6739 158.391 61.7892 158.19C61.9045 157.99 61.8377 157.733 61.6399 157.616L58.7911 155.932C58.5933 155.815 58.3395 155.883 58.2242 156.083Z",
    fill: "#FEAC06"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.2321 170.13C80.4144 169.99 80.6745 170.026 80.813 170.21L82.2086 172.073C82.3471 172.258 82.3115 172.521 82.1293 172.662C81.947 172.802 81.6869 172.766 81.5484 172.581L80.1528 170.719C80.0143 170.534 80.0499 170.27 80.2321 170.13Z",
    fill: "#FEAC06"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7886 170.373C65.6068 170.232 65.3466 170.267 65.2075 170.452L63.9846 172.072C63.8454 172.256 63.88 172.52 64.0618 172.661C64.2436 172.802 64.5038 172.767 64.6429 172.583L65.8658 170.963C66.0049 170.778 65.9704 170.514 65.7886 170.373Z",
    fill: "#FEAC06"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.2536 171.655C76.4638 171.563 76.7077 171.661 76.7982 171.874L78.863 176.734C78.9536 176.947 78.8566 177.194 78.6463 177.286C78.4361 177.378 78.1922 177.279 78.1016 177.066L76.0369 172.207C75.9463 171.994 76.0433 171.746 76.2536 171.655Z",
    fill: "#FEAC06"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8039 171.896C69.5932 171.805 69.3498 171.905 69.2604 172.119L67.3285 176.736C67.2391 176.949 67.3375 177.196 67.5482 177.287C67.759 177.377 68.0023 177.278 68.0917 177.064L70.0236 172.447C70.113 172.233 70.0146 171.987 69.8039 171.896Z",
    fill: "#FEAC06"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4483 167.117C84.5798 166.927 84.8383 166.881 85.0257 167.014L85.4743 167.333C85.6617 167.467 85.707 167.729 85.5755 167.919C85.4439 168.109 85.1854 168.155 84.998 168.021L84.5495 167.702C84.3621 167.569 84.3168 167.307 84.4483 167.117Z",
    fill: "#FEAC06"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.596 167.462C61.479 167.263 61.2246 167.197 61.0279 167.316L60.6324 167.554C60.4356 167.673 60.371 167.931 60.488 168.13C60.605 168.33 60.8594 168.395 61.0561 168.277L61.4516 168.038C61.6483 167.92 61.713 167.662 61.596 167.462Z",
    fill: "#FEAC06"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 36.1611,
    y: 133.063,
    width: 73.8701,
    height: 79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0196078 0 0 0 0 0 0 0 0 0 0.219608 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebration);
export default __webpack_public_path__ + "static/media/celebration.c68ae7ec15afc928a6f890238dc41627.svg";
export { ForwardRef as ReactComponent };